import { KgInsightSection } from '@api/api/kg-insights';
import { Button } from '@design/components/button/Button';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import styles from './SectionNav.module.scss';

export type SectionNavItem = {
  id: KgInsightSection['type'];
  label: string;
};

interface SectionNavProps {
  sections: SectionNavItem[];
  activeSectionId: string;
  onSectionClick: (id: string) => void;
  onDownload?: () => void;
}

export const SectionNav = ({
  sections,
  activeSectionId,
  onSectionClick,
  onDownload,
}: SectionNavProps) => {
  const { t } = useTranslation(['widget']);

  return (
    <nav className={styles.root}>
      {sections.map(section => (
        <button
          key={section.id}
          type="button"
          className={clsx(
            styles.item,
            section.id === activeSectionId && styles.active
          )}
          onClick={() => onSectionClick(section.id)}
        >
          {section.label}
        </button>
      ))}
      {onDownload && (
        <Button
          variant="tertiary"
          size="small"
          iconName="CloudArrowDown"
          label={t('widget:downloadInsight')}
          onClick={onDownload}
          className={styles.downloadButton}
        />
      )}
    </nav>
  );
};
